module.exports = __webpack_public_path__ + "img/SALES.29d51f60.png";